import {nonProfitRegister, terms, help, productionPage} from '../env-config'

export const  Links =  {
  help: help,
  terms: terms,
  charities: nonProfitRegister,
  productionPage: productionPage
}
